import { parsePhoneNumber } from "libphonenumber-js";
import {
	GB_RECENT_BOOKINGS,
	GB_SITE_POPULAR_ARRIVAL,
	GB_SITE_POPULAR_DEPARTURE,
} from "../constants/Options";
import { gbPopularDestination } from "../containers/redesign/homepage/constant";

export const GB_CONSTANT = {
	stripePublicKey: process.env.REACT_APP_STRIPE_PK_GB,
	placesAutocompletedLocation: {
		lat: 51.5074,
		lng: 0.1278,
	},
	addressCountry: "United Kingdom",
	billingAddressSelectStates: "UK",
	getPaymentFrequency: "Fortnightly",
	passportOrigin: "GB",
	bookingsEmail: "support@paylatertravel.uk",
	trustpilot: {
		locale: "en-GB",
		businessUnitID: "6023a4aac0f73e00011dcb3e",
		link: "https://www.trustpilot.com/review/paylatertravel.com",
	},
	homeflightMockup: "assets/images/paylaterflightswebusa.png",
	countryCode: "44",
	currencyCode: "GBP",
	supportMail: "support@paylatertravel.uk",
	formikMuiDateFormat: "DD/MM/YYYY",
	cardRental: "https://www.gotrentalcars.com/gb-label/?agence_id=5890",
	gaMeasuremntId: "G-P3RJJR6Z0Z",
	popularDestination: gbPopularDestination,
	popularDepartureDestination: GB_SITE_POPULAR_DEPARTURE,
	popularArrivalDestination: GB_SITE_POPULAR_ARRIVAL,
	dateOfBirthExample: "1997-12-30",
	phoneInputCountryCode: "GB",
	formatPhoneNumber: (phoneNumber) => {
		try {
			const parsedPhoneNumber = parsePhoneNumber(phoneNumber);
			return parsedPhoneNumber.formatInternational();
		} catch (_) {
			return phoneNumber;
		}
	},
	footerBrands: "/assets/redesign/icons/footer_stripe.svg",
};
